import "./App.css";
import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Button from "@material-ui/core/Button";
import AuthenticationModal from "./components/AuthenticationModal";
// import jsonpack from "jsonpack";
import InsuranceLanding from "./pages/use-cases/insurance/Landing";
import PotentialLanding from "./pages/use-cases/potential/Landing";
import PotentialLandingIssuer from "./pages/use-cases/potential/LandingIssuer";
import PotentialLandingVerifier from "./pages/use-cases/potential/LandingVerifier";
import { Col, Container, Row } from "react-bootstrap";
import { CredentialMapper } from "@sphereon/ssi-types";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import LifeInsurance from "./pages/use-cases/insurance/LifeInsurance";
import PrivateLiability from "./pages/use-cases/insurance/PrivateLiability";
import WelcomePage from "./pages/WelcomePage";
import { HotelLanding } from "./pages/use-cases/hotel/HotelLanding";
import { MyBookings } from "./pages/use-cases/hotel/MyBookings";
import { CheckIn } from "./pages/use-cases/hotel/CheckIn";
import { CheckOut } from "./pages/use-cases/hotel/CheckOut";
import { TelcoLanding } from "./pages/use-cases/telco/TelcoLanding";
import { CheckoutPage } from "./pages/use-cases/telco/CheckoutPage";
import Keycloak from 'keycloak-js';
import { TravelerProfilePage } from "./pages/use-cases/hotel/TravelerProfilePage";
import keycloak from "./KeycloakService";

const DEFAULT_FAVICON = "/favicon.ico";
const INSURANCE_FAVICON =
  "https://cdn-icons-png.flaticon.com/512/2237/2237686.png";
const HOTEL_FAVICON = "/static/media/hotel-logo.41ffb4eacbb4fd0d102d.png";
const TELCO_FAVICON = "/static/media/icon-1000px.d96f2153ecaaefbaac77.webp";

const setFavicon = (href: string) => {
  const head = document.head;
  const existingIcon = head.querySelector(
    "link[rel='icon']",
  ) as HTMLLinkElement | null;

  if (existingIcon) {
    existingIcon.href = href;
    return;
  }

  const link = document.createElement("link");
  link.rel = "icon";
  link.href = href;
  head.appendChild(link);
};

const RouteFaviconManager = () => {
  const location = useLocation();

  React.useEffect(() => {
    const path = location.pathname;

    if (
      path.startsWith("/insurance") ||
      path.startsWith("/life-insurance") ||
      path.startsWith("/private-liability-insurance") ||
      path.startsWith("/pinsurance") ||
      path.startsWith("/plife-insurance") ||
      path.startsWith("/pprivate-liability-insurance")
    ) {
      setFavicon(INSURANCE_FAVICON);
      return;
    }

    if (path.startsWith("/hotel")) {
      setFavicon(HOTEL_FAVICON);
      return;
    }

    if (path.startsWith("/telco")) {
      setFavicon(TELCO_FAVICON);
      return;
    }

    setFavicon(DEFAULT_FAVICON);
  }, [location.pathname]);

  return null;
};

export type AppState = {
  showAuthenticationModal?: boolean;
  payload?: AuthorizationResponsePayload;
  useCase?: string;
  useCaseUrl?: string;
  authenticated?: boolean;
  token?: string;
};

class App extends Component<AppState> {
  state: AppState = {};
  private readonly _stateStorageKey = "state-onto-app";

  constructor(props: AppState, context: any) {
    super(props, context);
    this.initState();
    if (document.location.pathname.startsWith("/simple")){
      this.state.useCase = "potential";
      this.state.useCaseUrl = "/simple";
    } else if (document.location.pathname.startsWith("/pinsurance")){
      this.state.useCase = "pinsurance";
      this.state.useCaseUrl = "/pinsurance";
    } else {
      this.state.useCase = "";
      this.state.useCaseUrl = "/";
    }

    
  }
  
  componentDidMount() {
    keycloak.init({ onLoad: 'login-required' }).then((auth) => {
      this.setState({ authenticated: auth });
    });
  }

  // componentDidMount(): void {
  //   const keycloak = new Keycloak({
  //     "realm": process.env.REACT_APP_KEYCLOAK_REALM ?? "",
  //     "url": process.env.REACT_APP_KEYCLOAK_URL ?? "",
  //     "clientId": process.env.REACT_APP_KEYCLOAK_CLIENT ?? "",
  //   });

  //   keycloak.init({ }).then((authenticated) => {
  //     if (authenticated) {
  //         console.log('User is authenticated');
  //         this.setState({authenticated: true, token: keycloak.token});
  //     } else {
  //         console.log('User is not authenticated');
  //         keycloak.login(); // {idpHint:'nca-sso'}
  //     }
  //   });
  // }

  render() {
    this.saveState();
    const payload = this.state.payload!;
    let setState = this.setState;
    return (
      <div>
        <style type="text/css">
          {`
                                    .btn-sphereon {
                                      background-color: #e8261f;
                                      color: white;
                                      border-radius: 0px;
                                    }
                                    
                                    .btn-sphereon:hover {
                                        background-color: #ba1e19;
                                        color: white;
                                        border-radius: 0px;
                                    }
                                    
                                    .btn-sphereon2 {
                                      background-color: #352575;
                                      color: white;
                                      border-radius: 0px;
                                    }
                                    
                                    .btn-sphereon2:hover {
                                        background-color: #ba1e19;
                                        color: white;
                                        border-radius: 0px;
                                    }
                                `}
        </style>
        <header
          className={
            "App-header" +
            (this.state.useCase != "" ? "-" + this.state.useCase : "")
          }
        >
          {/*<img style={{height: 50}}*/}
          {/*     src="https://sphereon.com/content/themes/sphereon/assets/img/logo.png?auto=compress&cs=tinysrgb&h=10"*/}
          {/*     alt="new"*/}
          {/*/>*/}
          {this.signInOutButtons()}
        </header>
        <Router>
          <RouteFaviconManager />
          <div style={{ display: "flex" }}>
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route path="/insurance" element={<InsuranceLanding />} />
              <Route
                path="/life-insurance"
                element={
                  <LifeInsurance
                    payload={payload}
                    onApply={() => this.showLoginDialog()}
                  />
                }
              />
              <Route
                path={"/private-liability-insurance"}
                element={
                  <PrivateLiability
                    payload={payload}
                    onApply={() => this.showLoginDialog()}
                  />
                }
              />
              <Route path="/simple" element={<PotentialLanding />} />
              <Route path="/simple/verifier" element={<PotentialLandingVerifier />} />
              <Route path="/simple/issuer" element={<PotentialLandingIssuer />} />
              <Route path="/simple" element={<PotentialLanding />} />
              <Route path="/pinsurance" element={<InsuranceLanding />} />
              <Route
                path="/plife-insurance"
                element={
                  <LifeInsurance
                    payload={payload}
                    onApply={() => this.showLoginDialog()}
                  />
                }
              />
              <Route
                path={"/pprivate-liability-insurance"}
                element={
                  <PrivateLiability
                    payload={payload}
                    onApply={() => this.showLoginDialog()}
                  />
                }
              />
              <Route path="/hotel" element={<HotelLanding payload={payload} onApply={() => this.showLoginDialog()} />} />
              <Route path="/hotel/mybookings" element={<MyBookings />} />
              <Route path="/hotel/check-in" element={<CheckIn payload={payload} onApply={() => this.showLoginDialog()}/>} />
              <Route path="/hotel/traveler-profile" element={<TravelerProfilePage payload={payload} onApply={() => this.showLoginDialog()}/>} />
              <Route path="/hotel/check-out" element={<CheckOut payload={payload} onApply={() => this.showLoginDialog()}  />} />
              <Route path="/telco" element={<TelcoLanding />} />
              <Route
                path="/telco/checkout"
                element={
                  <CheckoutPage
                    payload={payload}
                    onApply={() => this.showLoginDialog()}
                  />
                }
              />
            </Routes>
            <AuthenticationModal
              show={this.state.showAuthenticationModal as boolean}
              onCloseClicked={this.hideLoginDialog}
              onSignInComplete={this.completeSignIn}
            />
          </div>
        </Router>
      </div>
    );
  }

  private showLoginDialog = () => {
    this.setState({ showAuthenticationModal: true });
  };

  private hideLoginDialog = () => {
    this.setState({ showAuthenticationModal: false });
  };

  private completeSignIn = (payload: AuthorizationResponsePayload) => {
    this.setState({ showAuthenticationModal: false, payload });
  };

  private signOut = () => {
    this.setState({ payload: undefined });
  };

  private initState() {
    let storedState = sessionStorage.getItem(this._stateStorageKey);
    if (storedState != null) {
      this.loadState(storedState);
    } else {
      this.setState({ showAuthenticationModal: false });
    }
  }

  private loadState = (storedState: string) => {
    // eslint-disable-next-line react/no-direct-mutation-state
    // this.state = jsonpack.unpack(storedState) as AppState;
  };

  private saveState = () => {
    // sessionStorage.setItem(this._stateStorageKey, jsonpack.pack(this.state));
  };

  private signInOutButtons = () => {
    if (
      document.location.pathname === "/hotel" ||
      document.location.pathname === "/hotel/mybookings" ||
      document.location.pathname === "/hotel/check-in" ||
      document.location.pathname === "/telco" ||
      document.location.pathname === "/telco/checkout"
    ) {
      return;
    }

    const payload = this.state.payload!;

    // if (payload) {
    //   const presentation = CredentialMapper.toWrappedVerifiablePresentation(
    //     Array.isArray(payload.vp_token)
    //       ? payload.vp_token[0]
    //       : payload.vp_token!,
    //   );
    //   const subjects =
    //     presentation?.presentation?.verifiableCredential[0].credential
    //       .credentialSubject!; // Although rare, a VC can have more than one subject
    //   let subject2 = undefined;
    //   if (
    //     Array.isArray(presentation?.presentation?.verifiableCredential) &&
    //     presentation.presentation.verifiableCredential.length > 1
    //   ) {
    //     const subjects2 =
    //       presentation.presentation.verifiableCredential[1]!.credential
    //         .credentialSubject;
    //     if (subjects2) {
    //       if (Array.isArray(subjects2)) {
    //         subject2 = subjects2[0];
    //       } else {
    //         subject2 = subjects2;
    //       }
    //     }
    //   }

    //   const subject = Array.isArray(subjects) ? subjects[0] : subjects!;
    //   return (
    //     <Container fluid>
    //       <Row className="align-items-center">
    //         <Col className="col-4">
    //           <h5>Welcome {subject.name}</h5>
    //         </Col>
    //         <Col className="col-8" style={{ textAlign: "right" }}>
    //           <Button onClick={this.signOut} variant="contained">
    //             Sign out
    //           </Button>
    //         </Col>
    //       </Row>
    //     </Container>
    //   );
    // } else {
      return (
        <Container fluid>
          <Row>
            <Col className="col-11" style={{ justifyItems: "center" }}>
              <a href={this.state.useCaseUrl}>
                <img
                  style={{ width: "15rem" }}
                  //src="logo-nca-white.png"
                  src={
                    this.state.useCase != ""
                      ? "/" + this.state.useCase + "_logo.png"
                      : "/logo-nca-white.png"
                  }
                  alt="new"
                />
              </a>
            </Col>
            <Col className="col-1" style={{ textAlign: "right" }}>
              {/* <Button style={{width: "110px", backgroundColor: 'red', color: "white"}}
                                    onClick={this.showLoginDialog} variant="contained">Sign in</Button> */}
            </Col>
          </Row>
        </Container>
      );
    // }
  };
}

export default App;
